"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCOPE = exports.ENTRY = void 0;
exports.ENTRY = 1;
exports.SCOPE = 2;
//# sourceMappingURL=logger.types.js.map